import isDraftSignal from "app/pages/sales-intelligence/domain/signals/types/type-guards/isDraftSignal";

/** @deprecated use "app/pages/sales-intelligence/domain/signals/types/type-guards/isDraftSignal" */
export default isDraftSignal;
